export const DEFAULT_HOME_VERSES = [
  { text: 'For I know the plans I have for you, declares the Lord.', reference: 'Jeremiah 29:11' },
  { text: 'The Lord is my shepherd; I shall not want.', reference: 'Psalm 23:1' },
  { text: 'I can do all things through Christ who strengthens me.', reference: 'Philippians 4:13' },
  {
    text: 'Trust in the Lord with all your heart and lean not on your own understanding.',
    reference: 'Proverbs 3:5',
  },
  { text: 'God is our refuge and strength, a very present help in trouble.', reference: 'Psalm 46:1' },
  { text: 'Be strong and courageous. Do not be afraid; do not be discouraged.', reference: 'Joshua 1:9' },
  {
    text: 'The steadfast love of the Lord never ceases; his mercies never come to an end.',
    reference: 'Lamentations 3:22',
  },
  { text: 'The Lord bless you and keep you; the Lord make his face shine on you.', reference: 'Numbers 6:24-25' },
  {
    text: 'And we know that in all things God works for the good of those who love him.',
    reference: 'Romans 8:28',
  },
  { text: 'Let everything that has breath praise the Lord.', reference: 'Psalm 150:6' },
];

export function resolveHomeVerses(getContent) {
  const stored = getContent('home.verses.items', null);
  if (Array.isArray(stored) && stored.length) {
    return stored.map((verse, index) => ({
      text: verse.text || DEFAULT_HOME_VERSES[index]?.text || '',
      reference: verse.reference || DEFAULT_HOME_VERSES[index]?.reference || '',
    }));
  }

  return DEFAULT_HOME_VERSES.map((verse, index) => ({
    text: getContent(`home.verse.${index}.text`, verse.text),
    reference: getContent(`home.verse.${index}.ref`, verse.reference),
  }));
}
